import type dxForm from "devextreme/ui/form";

export async function validateDxFormAsync(form: dxForm)  {
    const syncValidationResult = form.validate();
    let asyncValidationResult;
    if (syncValidationResult?.status == "pending")
        asyncValidationResult = await syncValidationResult?.complete;
    const isValid = (syncValidationResult.isValid === true) &&
                    ((asyncValidationResult == null || asyncValidationResult!.isValid === true));
    return {
        isValid: isValid,
        brokenRules: [...syncValidationResult.brokenRules??[], asyncValidationResult?.brokenRules],
        syncValidationResult: syncValidationResult,
        asyncValidationResult: asyncValidationResult,
    };
}